define((require) => {
    "use strict";

    const AbstractWidgetModel   = require("shared/ui/experience/widgets/AbstractWidgetModel");
    const PolymorphicCollection = require("shared/zbone/PolymorphicCollection");
    const Injector              = require("shared/util/Injector");

    /**
     * A collection of widgets.
     *
     * @class WidgetCollection
     * @author Bruce Mackenzie Nielsen
     */
    return PolymorphicCollection.extend("WidgetCollection", {
        modelTypes() {
            return Injector.get("WidgetTypes");
        },

        modelClass:       "modelClass", // use the "modelClass" property from the deduced WidgetTypes constant to get the Model constructor.
        defaultModelType: AbstractWidgetModel
    });
});



// WEBPACK FOOTER //
// ./src/shared/ui/experience/widgets/WidgetCollection.js